
import { declareVrunComponent } from '/vodalys/vvuejs/declareVrunComponent.mjs'

declareVrunComponent('subtitleMain.vrun.component', () => import('./SubtitleMain.vue'))